import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

type ErrorMessageProps = {
  children: React.ReactNode;
  className?: string;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  children,
  className = "",
}) => (
  <div
    role="alert"
    aria-live="polite"
    className={`flex items-center rounded bg-red-100 p-3 text-sm text-red-700 ${className}`}
  >
    <ExclamationCircleIcon
      className="mr-2 inline-block h-5 w-5 shrink-0"
      aria-hidden="true"
    />
    {children}
  </div>
);

export default ErrorMessage;
